<template>
    <div>
         <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>

          <div class="row" v-if="!loading && stats">
            <div class="col-sm-12 col-md-2">
                <custom-chart type="pie" :datasets="chartDatasets" :labels="chartLabels" :options="chartOptions"></custom-chart>
            </div>
            <div class="col-sm-12 col-md-4">
                <div class="ix-table-box">
                    <table class="ix-table">
                        <tbody>
                            <tr v-for="(label , index) in itemsChart.labels" :key="index">
                                <td>
                                    <a :style="{'color' : itemsChart.datasets[0].backgroundColor[index]}" :href="'/public/'+ model +'s?state=' + itemsChart.states[index]">{{ label }}</a>
                                </td>
                                <td class="text-right">
                                    <div class="ix-dashboard-table-status-icon" v-bind:style="{'color' : itemsChart.datasets[0].backgroundColor[index]}">
                                         <span>{{ itemsChart.datasets[0].data[index] ? itemsChart.datasets[0].data[index] : 0 }}</span>
                                    </div>
                                   
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="ix-count-box mt-2">
                    <h2 class="ix-count-box-title">
                        Total HT
                    </h2>
                    <span class="ix-count-box-value">{{ currency(stats.total) }}</span>
                </div>

            </div>
            <div class="col-sm-12 col-md-6" v-if="lastItems && lastItems != null">
                <h5 v-if="model == 'quote'" class="ix-page-title-secondary">Liste des 5 derniers devis</h5>
                <h5 v-if="model == 'order'" class="ix-page-title-secondary">Liste des 5 dernières commandes</h5>
                <h5 v-if="model == 'invoice'" class="ix-page-title-secondary">Liste des 5 dernières factures</h5>

                <div class="ix-table-box">
                    <table class="ix-table">
                        <thead>
                            <tr>
                                <th>Numéro</th>
                                <th>Désignation</th>
                                <th class="text-right">Total HT</th>
                                <th class="text-right">Total TTC</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in lastItems" :key="i">
                                <td>{{ item.number }}</td> 
                                <td>{{ item.designation ? item.designation : '' }}</td>
                                <td class="text-right">
                                    {{ currency(item.total_ht) }}
                                </td>
                                <td class="text-right">
                                    {{ currency(item.total_ttc) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
    </div>
</template>

<script>
import CustomChart from '../CustomChart.vue';
export default {
    name: 'TradeStatistics',
    props: ['route', 'model', 'items'],
    components: {
        CustomChart,
    },
    data() {
        return {
            loading: true,
            stats : null,

            itemsChart: {
                options: {
                    plugins: {
                        legend: {
                            display: false,
                        }
                    }
                },
                datasets: [
                    {
                        label: "Statistiques",
                        data: [],
                    }
                ]
            },
            lastItems: null,
        }
    },
    computed: {
        chartDatasets() {
            return this.itemsChart ? this.itemsChart.datasets : [];
        },
        chartLabels() {
            return this.itemsChart ? this.itemsChart.labels : [];
        },
        chartOptions() {
            return this.itemsChart ? this.itemsChart.options : {};
        },
        chartStates() {
            return this.itemsChart ? this.itemsChart.states : [];
        }
    },
    methods: {
        getData : async function(){
                fetch(this.route + '?model=' + this.model, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.stats = data
                    
                    // Créer de nouveaux objets pour éviter les références circulaires
                    let chartData = [];
                    
                    switch(this.model){
                        case 'quote': 
                            chartData = [
                                data.items.quote_finished.count,
                                data.items.quote_accepted.count,
                                data.items.quote_refused.count,
                            ];
                        break;

                        case 'order': 
                            chartData = [
                                data.items.order_in_execution.count,
                                data.items.order_invoiced.count,
                                data.items.order_solded.count,
                                data.items.order_canceled.count,
                            ];
                        break;

                        case 'invoice': 
                            chartData = [
                                data.items.invoice_in_execution.count,
                                data.items.invoice_waiting_paiement.count,
                                data.items.invoice_partial_paiement.count,
                                data.items.invoice_payed.count,
                                data.items.invoice_canceled.count,
                                data.items.invoice_abandonned.count,
                            ];
                        break;
                    }

                    // Créer de nouveaux objets pour éviter les mutations
                    this.itemsChart = {
                        options: {
                            plugins: {
                                legend: {
                                    display: false,
                                }
                            }
                        },
                        labels: [...data.labels],
                        states: [...data.states],
                        datasets: [
                            {
                                label: "Statistiques",
                                data: chartData,
                                backgroundColor: [...data.background]
                            }
                        ]
                    };

                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
    },
    async mounted() {
        await this.getData();
        if(this.items)
            this.lastItems = JSON.parse(this.items);

    },
}
</script>